// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TqY4","col":"styles_col__1B6Pg"};